import { Link } from 'react-router-dom';
import { formatDateCN, formatViews, getCategoryName, type Video } from '@/utils/video';

interface VideoCardProps {
  video: Video;
  variant?: 'grid' | 'list';
}

export default function VideoCard({ video, variant = 'grid' }: VideoCardProps) {
  if (variant === 'list') {
    return (
      <Link
        to={`/detail/${video.id}`}
        className="group flex gap-3 md:gap-4 rounded-lg bg-background-50 border border-background-200 p-3 hover:border-accent-300 transition-colors cursor-pointer"
      >
        <div className="relative w-40 sm:w-48 md:w-56 shrink-0 aspect-video overflow-hidden rounded-md bg-background-200">
          <img
            src={video.cover}
            alt={video.title}
            title={`${video.title} - 宅男视频`}
            className="w-full h-full object-top object-cover transition-transform duration-500 group-hover:scale-105"
          />
          <span className="absolute bottom-1.5 right-1.5 px-1.5 py-0.5 rounded bg-black/70 text-[11px] text-white tabular-nums">
            {video.duration}
          </span>
        </div>
        <div className="flex flex-col min-w-0 flex-1 py-0.5">
          <h3 className="text-sm md:text-base font-semibold text-foreground-950 line-clamp-2 group-hover:text-accent-600 transition-colors">
            {video.title}
          </h3>
          <p className="mt-2 text-xs md:text-sm text-foreground-600 line-clamp-2 hidden sm:block">
            {video.description}
          </p>
          <div className="mt-auto pt-2 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-500">
            <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900">
              {getCategoryName(video.category)}
            </span>
            <span className="inline-flex items-center gap-1">
              <i className="ri-play-fill"></i>
              {formatViews(video.views)}
            </span>
            <span className="inline-flex items-center gap-1">
              <i className="ri-time-line"></i>
              {formatDateCN(video.publishedAt)}
            </span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/detail/${video.id}`}
      className="group flex flex-col rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-accent-300 transition-colors cursor-pointer animate-fade-up"
    >
      <div className="relative w-full aspect-video overflow-hidden bg-background-200">
        <img
          src={video.cover}
          alt={video.title}
          title={`${video.title} - 宅男视频`}
          className="w-full h-full object-top object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute bottom-2 right-2 px-1.5 py-0.5 rounded bg-black/70 text-[11px] text-white tabular-nums">
          {video.duration}
        </span>
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-full bg-accent-500 text-[11px] font-medium text-primary-950">
          {getCategoryName(video.category)}
        </span>
      </div>
      <div className="flex flex-col flex-1 p-3 md:p-4">
        <h3 className="text-sm md:text-base font-semibold text-foreground-950 line-clamp-2 group-hover:text-accent-600 transition-colors">
          {video.title}
        </h3>
        <div className="mt-auto pt-3 flex items-center justify-between text-xs text-foreground-500">
          <span className="inline-flex items-center gap-1">
            <i className="ri-play-fill"></i>
            {formatViews(video.views)} 次播放
          </span>
          <span className="inline-flex items-center gap-1">
            <i className="ri-user-3-line"></i>
            {video.author}
          </span>
        </div>
      </div>
    </Link>
  );
}